import React from 'react';
import { SectionHeading } from './SectionHeading';
import { painQuestions } from '../data/content';
export function PainSection() {
  return <section className="border-y-4 border-cream-deep bg-white px-4 py-6 sm:px-6" data-id="element-161" data-mp="38x5bk8ofrev8">
      <SectionHeading size="lg" data-id="element-162" data-mp="2uxdrprb8n49b">
        😰 Stop planning every activity from scratch
      </SectionHeading>

      <div className="mx-auto mt-3 max-w-2xl text-center text-[13px] font-medium leading-snug text-graphite sm:text-sm" data-id="element-163" data-mp="2yy61clo0vb64">
        <p data-id="element-164" data-mp="2l6j3wiicfwlr">
          Maybe you already know how to engage your residents or participants.{' '}
          <strong className="font-bold text-navy" data-id="element-165" data-mp="2q15e4icovj49">
            That’s not the problem.
          </strong>
        </p>
        <p className="mt-1.5" data-id="element-166" data-mp="2g9988l4d2oph">
          The problem starts when you have to keep coming up with activities.
        </p>
      </div>

      <ul className="mx-auto mt-3 grid max-w-2xl gap-1 sm:grid-cols-2" data-id="element-167" data-mp="22aj8syu2kcxy">
        {painQuestions.map(question => <li key={question} className="rounded bg-cream px-3 py-1.5 text-[12px] font-semibold italic leading-snug text-graphite sm:text-[13px]" data-id="element-168" data-mp="2779r7stcjkmj">
            “{question}”
          </li>)}
      </ul>

      <p className="mt-3 text-center text-[13px] font-bold text-terracotta sm:text-sm" data-id="element-169" data-mp="5fsskto977gf">
        And tomorrow… You have to do it all over again.
      </p>

      <p className="mt-2 text-center font-heading text-base font-extrabold uppercase leading-tight text-navy sm:text-lg" data-id="element-170" data-mp="i0zhwbvhfan">
        You don’t need more scattered inspiration.
        <br data-id="element-171" data-mp="33y7u7dcb827a" />
        You need ready-to-use structure.
      </p>
    </section>;
}